module.exports = __webpack_public_path__ + "static/flying_chariot-61bb929fa93c902f4c180a93908e523b.jpg";